import copyAnimationData from '@/shared/animations/copy.json';
import IconButton, { type IconButtonVariant } from '@/shared/components/molecules/IconButton';
import { copy } from '@/shared/utils/helpers';
import Lottie from '@/shared/utils/Lottie';

interface CopyButtonProps {
  textToCopy: string;
  size?: Size;
  disabled?: boolean;
  variant?: IconButtonVariant;
}

type Size = 'small' | 'large';

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  size = 'large',
  disabled,
  variant,
}): React.JSX.Element => (
  <IconButton
    size={size}
    variant={variant}
    onClick={() => {
      if (!disabled) {
        copy(textToCopy);
      }
    }}
    disabled={disabled}
  >
    <Lottie
      as="button"
      className="h-4 w-4"
      animationData={copyAnimationData}
      autoplay={false}
      speed={1}
      loop={false}
      playOnce
      disabled={disabled}
    />
  </IconButton>
);

export default CopyButton;
